import * as React from 'react';
import withStyles from '@mui/styles/withStyles';
import { colors } from 'spw-theme';
import styled, { css } from 'styled-components';
import MaterialTooltip from '@mui/material/Tooltip';

export const BubbleIcon = styled.div`
  && {
    width: 18px;
    height: 18px;
    border-radius: 9px;
    background-color: ${(props) => props.color} !important;
  }
`;

interface BubbleProps {
  currentCategory: string;
  color?: string;
}

type ColorsType = keyof typeof colors;

export const Bubble: React.FunctionComponent<BubbleProps> = ({
  currentCategory,
  color,
}: BubbleProps) => {
  let backgroundColor = colors[currentCategory as ColorsType] as string;

  if (color) {
    backgroundColor = color;
  }
  return <BubbleIcon color={backgroundColor} />;
};

export const TooltipButton = styled.div`
  margin-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  ${(props) =>
    props.theme.show &&
    css`
      background-image: url('/images/tooltip-ellipse.svg');
      background-size: 16px 16px;
    `}
`;

export const Tooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: 'white',
    padding: 0,
    margin: '0px',
  },
}))(MaterialTooltip);
